module.exports = __webpack_public_path__ + "static/Wendy-408aa90c7d35b50aae7445722451d04d.png";